import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectLayoutType = createSelector(selectJsonQuery, jsonQuery => getTermValue('room_type')(jsonQuery));
